<template>
  <div class="container" id="forgot-password-page">
    <h1 class="page-title">{{ $t("form.forgot_password.title") }}</h1>
    <hr>
    <div class="row">
      <div class="col-12 col-md-6 offset-md-3 text-center form-forgot-password">
        <form @submit.prevent="recoverPassword" class="p-t-15" role="form" novalidate="novalidate">
          <div class="guilde-line-1">
            {{ $t("form.forgot_password.main_guide_line") }}
          </div>
          <div class="p-b-20 guilde-line-2">
            <i>{{ $t("form.forgot_password.sub_guide_line") }}</i>
          </div>
          <div class="form-group form-group-default">
            <label class="text-left">{{ $t("SignInForm.email") }}*</label>
            <div class="controls">
              <input v-model="email" v-validate="'required|email'"  type="text" name="email" class="form-control" required="" id="email" aria-required="true">
            </div>
          </div>
          <transition name="slide-fade">
            <label v-show="errors.has('email')" id="email-error" class="error text-left" for="email">{{ errors.first('email') }}</label>
          </transition>
          <button class="btn btn-danger btn-block m-t-15 p-t-15 p-b-15" :disabled="errors.items.length > 0 || email.length == 0">
            {{ $t("form.forgot_password.button") }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    data: function() {
      return ({
        email: ''
      })
    },
    methods: {
      recoverPassword() {
        this.$store.dispatch('recoverPassword/requestResetPassword', this.email)
      }
    }
  }
</script>

<style type="text/css">
  button.btn-block {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/recoverPassword/ForgotPasswordForm.vue